import React from 'react';
import PropTypes from 'prop-types';

const LocationInfoOverlay = ({
  location,
  address,
  mode,
  areaHectares,
  areaAcres,
  perimeter
}) => {
  if (!location) return null;
  return (
    <div
      className="leaflet-bottom leaflet-left"
      style={{
        bottom: '20px',
        left: '10px',
        zIndex: 1000,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        padding: '10px',
        borderRadius: '4px',
        maxWidth: '300px',
        boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
      }}
    >
      <div style={{ fontSize: '12px' }}>
        {mode == 'location' && (
          <div style={{ marginBottom: '5px' }}>
            <strong>Address:</strong> {address || 'Loading...'}
          </div>
        )}
        {mode == 'polygon' && (
          <div style={{ marginBottom: '5px' }}>
            Area: {areaHectares.toFixed(2)} ha / {areaAcres.toFixed(2)} acres /{' '}
            {perimeter.toFixed(2)} m perimeter
          </div>
        )}
      </div>
    </div>
  );
};
LocationInfoOverlay.propTypes = {
  location: PropTypes.shape({
    lat: PropTypes.number.isRequired, // Latitude must be a number
    lng: PropTypes.number.isRequired // Longitude must be a number
  }),
  address: PropTypes.string,
  mode: PropTypes.oneOf(['location', 'polygon']),
  perimeter: PropTypes.number,
  areaAcres: PropTypes.number,
  areaHectares: PropTypes.number
};

LocationInfoOverlay.defaultProps = {
  perimeter: 0,
  areaAcres: 0,
  areaHectares: 0
};

export default LocationInfoOverlay;
